import { Navigate } from "react-router";

import { Permission } from "../auth/permissions";
import { RequirePermission } from "../auth/RequirePermission";

interface PrivateRouteProps {
  children: React.ReactNode;
  /**
   * Capability required to open this route. Omit for screens any authenticated
   * operator may see.
   *
   * This used to check nothing beyond "a token string exists in localStorage",
   * so every admin screen - including plan pricing, which rewrites Stripe
   * Prices - was reachable by anyone holding a session. The key must match the
   * one the corresponding API endpoint authorises on, so the menu, the screen
   * and the server all agree.
   */
  permission?: Permission | string;
  /** Holding ANY of these opens the route. Use for aggregate screens. */
  anyOf?: (Permission | string)[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  permission,
  anyOf,
}) => {
  const hasToken = !!localStorage.getItem("token");

  if (!hasToken) {
    return <Navigate to="/" replace />;
  }

  if (permission || anyOf) {
    return (
      <RequirePermission permission={permission} anyOf={anyOf}>
        {children}
      </RequirePermission>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;
